/**
 *
 * Asynchronously loads the component for FeeReceiptTwo
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const FeeReceiptTwo = lazyLoad(
    () => import('./index'),
    module => module.default,
);
